// @flow
import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import Link from 'react-router-dom/Link';
import { StyleSheet, css } from 'aphrodite';

import Routes from './Routes';

import { ApolloProvider } from 'react-apollo';
// import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';



var uri = "https://minimaa.herokuapp.com/graphql";
// if(process.env.NODE_ENV === "development") uri = "http://localhost:8000/graphql";
// if(process.env.NODE_ENV === "test") uri = "https://minimaa-staging.herokuapp.com/graphql";



const httpLink = createHttpLink({
  uri: uri,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'x-token': token ? `${token}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

@autobind
class App extends React.Component {
  state = {

  };
  setSmartlookWidget() {
    return {
      __html: `
        window.smartlook||(function(d) {
        var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
        var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
        c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);
        })(document);
        smartlook('init', '160b95b9ad41f446511df337cd29d61b41bc4408');
      `
    };
  }

  setGoogleTags() {
    return {
      __html: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-138317768-1');
        gtag('config', 'UA-138317768-1', { 'optimize_id': 'GTM-WHKSNLM'});
      `
    };
  }

  setTagManagerWidget() {
    return {
      __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MNDSBGD');
      `
    };
  }
  intercomWidget() {
    return {
      __html: `
        (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/uxelpym5';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
      `
    };
  }


  render() {
    return (
     
        <BrowserRouter>
          <ApolloProvider client={client}>
            <div className={css(styles.wrapper)}>
              <Routes />
              {process.env.NODE_ENV !== "development" &&
                <React.Fragment>
                  <script dangerouslySetInnerHTML={this.setSmartlookWidget()}/>
                  <script dangerouslySetInnerHTML={this.setGoogleTags()}/>
                  <script dangerouslySetInnerHTML={this.setTagManagerWidget()}/>
                  <script async src="https://www.googletagmanager.com/gtag/js?id=UA-138317768-1"></script>
                </React.Fragment>
              }

              <div style={{display:"none"}}>
                <Link to="/terms-and-conditions"></Link>
                <Link to="/explore"></Link>
              </div>

            </div>
          </ApolloProvider>
        </BrowserRouter>
  
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    margin:"0 auto",
    position:"relative",
  },

});

export default App;
